import {Component} from 'panel';

import {registerMPElement} from 'common/util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

export const THEME = {
  GENERIC: `generic`,
  INFORMATION: `information`,
  SUCCESS: `success`,
  DELETED: `deleted`,
  FAILED: `failed`,
  POSITIVE: `positive`,
  NEGATIVE: `negative`,
  NEUTRAL: `neutral`,
};

export const SIZE = {
  SMALL: `small`,
  MEDIUM: `medium`,
  LARGE: `large`,
};

export default registerMPElement(
  `mp-text-highlight`,
  class extends Component<{}> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        size: {type: `string`, default: SIZE.MEDIUM, enum: Object.values(SIZE)},
        theme: {type: `string`, default: THEME.NEUTRAL, enum: Object.values(THEME)},
        text: `string`,
      };
    }

    get config() {
      return {
        useShadowDom: true,
        template,
        css,
        helpers: {
          THEME,
          SIZE,
        },
      };
    }
  },
);
